<template>
    <transition name="fade">
        <div v-if="showing">
            <div class="modal-container" v-on:click="close">
                <div class="horizontal">
                    <div class="modal-content" v-on:click.stop>
                        <div class="title">{{l10nAddedToCart}}</div>
                        <div class="divider-container">
                            <div class="divider"></div>
                        </div>
                        <div class="variant">
                            <span>{{cartItem.name}}</span>
                        </div>
                        <div class="variant">
                            <span>{{cartItem.variant}}</span>
                        </div>
                        <div class="variant">
                            <span>{{l10nQuantity}}: {{cartItem.quantity}}</span>
                        </div>
                        <div class="price-container">
                            <span class="price">
                                <span>{{totalPrice}}</span>
                                <span>$</span>
                            </span>
                        </div>
                        <div class="action-area">
                            <span class="view-cart">
                                <jabra-btn v-on:jbr-click="navigateToCart()">
                                    <div class="view-cart-slot">{{l10nViewCart}}</div>
                                </jabra-btn>
                            </span>
                            <span class="continue-shopping">
                                <jabra-btn dark v-on:jbr-click="close()">
                                    <div class="continue-shopping-slot">{{l10nContinueShopping}}</div>
                                </jabra-btn>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import {
        INIT_ADDED_TO_CART_MODAL,
        EVENT_SHOW_STATE,
    } from '../services/constants'

    import helpers from '../services/helpers'

    export default {
        name: 'jabra-added-to-cart-modal',
        computed: {
            showing() {
                return this.$store.state.commerceModule.addedToCartModal.props.showing
            },
            cartItem() {
                return this.$store.state.commerceModule.addedToCartModal.props.cartItem
            },
            totalPrice() {
                return this.cartItem.unitPrice * this.cartItem.quantity
            },
            l10nAddedToCart() {
                return this.l10nGetter('added_to_cart')
            },
            l10nQuantity() {
                return this.l10nGetter('quantity')
            },
            l10nViewCart() {
                return this.l10nGetter('view_cart')
            },
            l10nContinueShopping() {
                return this.l10nGetter('continue_shopping')
            },

        },
        methods: {
            close() {
                this.$emit(EVENT_SHOW_STATE, false)
            },
            navigateToCart() {
                this.close()
                this.$router.push({name: 'cart'})
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
        },
        created() {
            this.$store.commit(INIT_ADDED_TO_CART_MODAL, this)
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .modal-container {
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(128, 128, 128); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.5); /* Black w/ opacity */
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .horizontal {
        display: flex;
        justify-content: center;
    }

    .modal-content {
        background-color: #fefefe;
        /*margin: 15% auto; !* 15% from the top and centered *!*/
        padding: 155px 150px 88px 150px;
    }

    .title {
        @include font-abraham(50px, $font-color-blue, 400);
        text-transform: uppercase;
        display: flex;
        justify-content: center;
    }

    .header {
        border-bottom: $grey-3 solid 1px;
    }

    .divider-container {
        display: flex;
        justify-content: center;
    }

    .divider {
        width: 60px;
        height: 8px;
        margin: 30px;
        background: $accent-1;
    }

    .variant, .price-container {
        display: flex;
        justify-content: center;
    }

    .action-area {
        display: flex;
        justify-content: space-between;
    }

    .variant {
        @include font-abraham(30px, $font-color-blue, 300);
        margin: 0 0 40px 0;
    }

    .price-container {
        .price {
            padding: 0 90px;
            background: $accent-2;
            line-height: 40px;
            @include font-abraham(28px, $font-color-blue, 400);
        }
        margin: 0 0 85px 0;
    }

    .action-area {
        display: flex;
        justify-content: space-between;
    }

    .continue-shopping {
        margin: 0 0 0 23px;
    }

    .view-cart {
        margin: 0 23px 0 0;
    }

    .view-cart-slot, .continue-shopping-slot {
        font-size: 24px;
        line-height: 50px;
        min-width: 190px;
    }


</style>
